<!-- 验收工单 -->
<template>
  <div>
    <el-dialog :title="type === '0' ? '验收工单' : '反馈问题'" :close-on-click-modal="false" v-el-drag-dialog
      :visible.sync="dialogVisible" @close="changeClose">
      <el-form :model="submitForm" label-width="95px" :rules="submitRules" ref="submitFormRef" v-loading="loading">
        <el-form-item v-if="type === '0'" label="验收评分：" class="flex-col-center">
          <el-rate v-model="submitForm.score"></el-rate>
        </el-form-item>
        <el-form-item :label="type === '0' ? '我的想法：' : '我的反馈：'" prop="content">
          <el-input v-model="submitForm.content" :placeholder="type === '0' ? '请输入详细评价' : '请输入您的反馈'" type="textarea"
            :autosize="{ minRows: 5}"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="submit" :loading="loading">立即提交</el-button>
        <el-button v-if="type === '0'" type="warning" @click="type = '1'" :loading="loading">验收不通过？</el-button>
        <el-button v-else type="warning" @click="type = '0'" :loading="loading">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      type: '0', // 0 验收 1 不通过
      id: '', // 工单id
      // 验收表单
      submitForm: {
        score: 0,
        content: '',
        evaluateFiles: []
      },
      submitRules: {
        content: { required: true, message: '请输入详细评价', trigger: 'blur' }
      },
      loading: false
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {
    open(data) {
      this.id = data.sheetId
      this.dialogVisible = true
    },

    submit() {
      this.$refs.submitFormRef.validate((valid) => {
        if (valid) {
          this.$confirm(
            `您是否确定${this.type === '0' ? '验收' : '反馈'}该工单?`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.loading = true
              const apiType =
                this.type === '0' ? 'sheetEvaluate' : 'sheetEvaluateUnPass'
              this.$api.order[apiType]({
                ...this.submitForm,
                sheetId: this.id
              })
                .then(({ data }) => {
                  this.loading = false
                  if (data.code == 200) {
                    this.$notify.success({
                      title: '提示',
                      message: this.type === '0' ? '验收成功' : '反馈成功'
                    })
                    this.dialogVisible = false
                    this.$emit('refresh', 2)
                  }
                })
                .catch(() => {
                  this.loading = false
                })
            })
            .catch(() => {})
        } else {
          return false
        }
      })
    },

    changeClose() {
      this.$refs.submitFormRef.resetFields()
    }
  }
}
</script>

<style lang='scss' scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>
